import Scene from '../configurator/scenes/scene';

export const scene = new Scene();
